import type { ReactNode } from 'react';

import { PrimaryNavigationClientWrapper } from './PrimaryNavigationClientWrapper';
import { ResponsiveNavigationLayoutWrapper } from './ResponsiveNavigationLayoutWrapper';

export type ResponsiveNavigationLayoutProps = {
  children: ReactNode;
  button: ReactNode;
  hamburgerShouldBeMounted: boolean;
  hamburgerClassNames: string;
  isLevel2Visible?: boolean;
  onClickAway?: () => void;
};

export const ResponsiveNavigationLayout = ({
  children,
  button,
  hamburgerClassNames,
  hamburgerShouldBeMounted,
  isLevel2Visible,
  onClickAway,
}: ResponsiveNavigationLayoutProps) => (
  <ResponsiveNavigationLayoutWrapper
    isLevel2Visible={isLevel2Visible}
    hamburgerShouldBeMounted={hamburgerShouldBeMounted}
    button={button}
  >
    <PrimaryNavigationClientWrapper
      onClickAway={onClickAway}
      hamburgerClassNames={hamburgerClassNames}
      hamburgerShouldBeMounted={hamburgerShouldBeMounted}
    >
      {children}
    </PrimaryNavigationClientWrapper>
  </ResponsiveNavigationLayoutWrapper>
);
